import { alpha3ToAlpha2 } from "i18n-iso-countries";
import ReactCountryFlag from "react-country-flag";

export function CountryFlag({ iso3 }: { iso3: string | null | undefined }) {
  if (!iso3) return null;
  const alpha2 = alpha3ToAlpha2(iso3.toUpperCase());
  if (!alpha2) return null;
  const name = new Intl.DisplayNames(["en"], { type: "region" }).of(alpha2) ?? iso3;
  return <ReactCountryFlag className="country-flag" countryCode={alpha2} title={name} svg={false} />;
}